import { render } from "./terms-view-component.vue?vue&type=template&id=d2247e10&scoped=true&ts=true"
import script from "./terms-view-component.vue?vue&type=script&lang=ts"
export * from "./terms-view-component.vue?vue&type=script&lang=ts"

import "./terms-view-component.vue?vue&type=style&index=0&id=d2247e10&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2247e10"]])

export default __exports__